module.exports = __webpack_public_path__ + "img/bannerTow.eb36fba4.jpg";